// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"ef3f0a15","787":"7b2b127c"}[chunkId] + ".chunk.js";
};